export const pipelineTypes = [
  'ATMOS Pipeline',
  'Abnormal Operating Conditions',
  'Pipeline OQ',
  'Pipeline Training and Qualifications Program',
  'Pipeline Training & Qualifications Program',
];
